"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.certificationIconSize = exports.certificationIconWidth = exports.certificationIconHeight = exports.tooltipStyle = exports.tooltipSize = exports.mediumSpace = exports.largeSpace = exports.defaultSpace = exports.discreteDarkColor = exports.secondaryFontColor = exports.primaryFontColor = exports.tinyFontSize = exports.defaultFontSize = exports.defaultFontFamily = void 0;
var widgets_1 = require("@tableau/widgets");
// Tableau styles
var Typography = widgets_1.TabStyles.Typography, Colors = widgets_1.TabStyles.Colors, Spacing = widgets_1.TabStyles.Spacing;
exports.defaultFontFamily = 'inherit';
exports.defaultFontSize = Typography.Sizing.Default;
exports.tinyFontSize = Typography.Sizing.Tiny;
exports.primaryFontColor = Typography.Color.Primary;
exports.secondaryFontColor = Typography.Color.Secondary;
exports.discreteDarkColor = Colors.DiscreteDark;
exports.defaultSpace = Spacing.DefaultSpace;
exports.largeSpace = Spacing.LargeSpace;
exports.mediumSpace = Spacing.MediumSpace;
// Tooltip styles
exports.tooltipSize = 300;
exports.tooltipStyle = {
    fontFamily: exports.defaultFontFamily,
    fontSize: exports.defaultFontSize
};
// Icon styles
exports.certificationIconHeight = 19;
// Total width of certification icon including padding within the image.
exports.certificationIconWidth = 24;
// For some reason we use the height for both dimensions.
exports.certificationIconSize = exports.certificationIconHeight;
//# sourceMappingURL=Style.js.map